export class Sucursal {
    idsucursal?:number;
    nombre?:string;
    direccion?:string;
    region?:string;
    telefono?:string;
    fax?:string;
    email?:string;
    notas?:string;
    empresa?:any;
}
